import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { withStyles, makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Button from 'components/CustomButtons/Button.js';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';

import { wsGetAll } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import { Collapse, TextField } from '@material-ui/core';
import { wsFindBy } from 'services/WService';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { wsCreate } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1)
  }
}))(MuiDialogActions);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Estado', accessor: 'state' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default WithApp(function BusinessTurnModal(props) {
  const { addressId, open, close } = props;

  const handleClose = () => {
    close(false);
  };
  const [checkDisplay, setCheckDisplay] = useState(false);

  const [bTurns, setBTurns] = useState([]);

  const [bPartners, setBPartners] = useState([]);
  const [businessTs, setBusinessTs] = useState([]);

  const [providerSelect, setProviderSelect] = useState(null);
  const [bLineSelect, setBLineSelect] = useState(null);

  async function listBusinessTurns() {
    let response = await wsGetAll('base/address/' + addressId + '/business-lines');
    if (response.success) setBTurns(response.data);
  }

  async function getBPartners() {
    let response = await wsFindBy('base/business-partner', { CardType: 'S', QryGroup1: 'Y' });
    if (response.success) {
      setBPartners(response.data)
      setProviderSelect(response.data.find((bp) => bp.id == 1) || null);
    };
  }

  async function getBusinessTs(provider) {
    if(provider === null) return;
    let response = await wsFindBy('base/business-line', 'base_business_partner_id', provider.id);
    if (response.success) setBusinessTs(response.data);
  }

  async function saveBusinessTurn(bLineSelect) {
    let bLine = { base_business_line_id: bLineSelect };
    let response = await wsCreate('base/address/' + addressId + '/business-lines', bLine);
    if (response.success) {
      getBusinessTs(providerSelect);
      setProviderSelect(null);
      setProviderSelect(bPartners.find((bp) => bp.id == 1) || null);
      setBLineSelect(null);
      setCheckDisplay(false);
      props.showNotify(response.message);
    } else {
      props.showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    if (open) listBusinessTurns();
    if (checkDisplay) getBPartners();
  }, [open, checkDisplay]);

  useEffect(() => {
    if (providerSelect !== null) {
      getBusinessTs(providerSelect);
    }
  }, [providerSelect]);

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xl">
      <DialogTitle onClose={handleClose}>Giros de negocio</DialogTitle>
      <DialogContent dividers>
        <GridContainer>
          <GridItem xs={12}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                saveBusinessTurn(bLineSelect);
              }}
            >
              <AllowedGuard
                permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_ADD}
              >
                {checkDisplay ? (
                  <Button color={props.themeContext.buttonColorSuccess} size="sm" type="submit">
                    Guardar
                  </Button>
                ) : (
                  <Button
                    color={props.themeContext.buttonColorSuccess}
                    onClick={(e) => {
                      e.preventDefault();
                      setCheckDisplay(true);
                    }}
                    size="sm"
                    type="button"
                  >
                    Nuevo
                  </Button>
                )}
                <Button
                  color={props.themeContext.buttonColorDanger}
                  onClick={() => {
                    setCheckDisplay(false);
                    setProviderSelect(null);
                    setBLineSelect(null);
                  }}
                  size="sm"
                  type="button"
                >
                  Cancelar
                </Button>
              </AllowedGuard>
              <Collapse in={checkDisplay}>
                <div elevation={4} style={{ padding: '10px' }}>
                  {checkDisplay ? (
                    <GridContainer>
                      <GridItem xs={4}>
                        <Autocomplete
                          options={bPartners}
                          getOptionLabel={(option) => option.CardName}
                          renderInput={(params) => (
                            <TextField {...params} label="Proveedor" margin="normal" required />
                          )}
                          value={providerSelect}
                          onChange={(e, item) => {
                            if (!!item) {
                              setBLineSelect(null);
                              return setProviderSelect(item);
                            } else {
                              setProviderSelect(null);
                            }
                          }}
                        />
                      </GridItem>
                      <GridItem xs={4}>
                        <Autocomplete
                          key={providerSelect}
                          options={businessTs}
                          getOptionLabel={(option) => option.description}
                          renderInput={(params) => (
                            <TextField {...params} label="Giro negocio" margin="normal" required />
                          )}
                          onChange={(e, item) => {
                            if (!!item) {
                              return setBLineSelect(item.id);
                            } else {
                              setBLineSelect(null);
                            }
                          }}
                        />
                      </GridItem>
                    </GridContainer>
                  ) : (
                    <></>
                  )}
                </div>
              </Collapse>
            </form>
          </GridItem>
          <GridItem xs={12}>
            <Card>
              <CardHeader icon></CardHeader>
              <CardBody>
                <ReactTable
                  defaultWidth={1300}
                  indexRow={[1, 4, 5]}
                  widthRow={[150, 100, 1]}
                  columns={columns}
                  data={bTurns.map((bTurn, i) => {
                    return {
                      num: (
                        <div className="actions-right">
                          {i + 1}
                          <AllowedGuard
                            permission={
                              ConstantPermissions.BASE_BUSINESS_PARTNERS_ADDRESS_BUSINESS_LINE_REMOVE
                            }
                          >
                            <ButtonDelete
                              entity={`base/address/${addressId}/business-lines`}
                              id={bTurn.id}
                              reload={listBusinessTurns}
                            />
                          </AllowedGuard>
                        </div>
                      ),
                      code: bTurn.code,
                      description: bTurn.description,
                      CardName: bTurn.CardName,
                      state: bTurn.state === 'A' ? 'Activo' : 'Inactivo',
                      actions: '',
                    };
                  })}
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleClose} color={props.themeContext.buttonColorDanger}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
});
